var _rect, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUqModule(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 63,
    viewBox: "0 0 81 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 12,
    width: 39,
    height: 39,
    rx: 3.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9484 23.4514C37.1662 23.7752 36.4591 24.2563 35.8711 24.8648C35.2614 25.4633 34.8014 26.1968 34.5283 27.006C34.181 27.7997 34.0045 28.6574 34.0101 29.5236C34.0046 30.3746 34.1813 31.217 34.5283 31.9942C34.8539 32.78 35.3346 33.4922 35.9418 34.0883C36.5424 34.6684 37.2349 35.1454 37.9912 35.5C38.7685 35.8493 39.6124 36.0259 40.4647 36.0177H40.5118V39.4765H40.4647C39.1527 39.4828 37.8535 39.2184 36.6485 38.7C35.4497 38.1935 34.3615 37.4582 33.4447 36.5353C32.5259 35.6154 31.7904 34.5295 31.2775 33.3353C30.7585 32.1317 30.4938 30.8341 30.5001 29.5236C30.4938 28.1827 30.7582 26.8543 31.2775 25.6177C31.7842 24.4133 32.5203 23.3185 33.4447 22.3942C34.3615 21.4831 35.4505 20.7633 36.6485 20.2766C37.8535 19.7582 39.1527 19.4938 40.4647 19.5001C41.8072 19.4938 43.1372 19.7579 44.3752 20.2766C45.5844 20.7549 46.6828 21.4755 47.6025 22.3942C48.5222 23.3128 49.2437 24.4099 49.7226 25.6177C50.2397 26.8549 50.504 28.1829 50.5 29.5236C50.4968 30.5052 50.3459 31.4809 50.0524 32.4177L46.8486 30.5824C46.915 30.2335 46.9466 29.8788 46.9429 29.5236C46.9461 28.6576 46.7697 27.8004 46.4246 27.006C46.0906 26.2234 45.62 25.5064 45.0347 24.8883C44.4516 24.2713 43.7343 23.7963 42.9382 23.5001C42.145 23.1486 41.2853 22.9721 40.4176 22.9824C39.571 22.9679 38.7305 23.1276 37.9484 23.4514ZM44.8699 33.5236L49.1596 36.0059L49.1808 35.9942V41.0059L44.8228 43.5V38.5118L40.5118 36.0177L44.8699 33.5236Z",
    fill: "#80959B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 12,
    width: 39,
    height: 39,
    rx: 3.5,
    stroke: "#E6EAEB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUqModule);
export default __webpack_public_path__ + "static/media/UqModule.31ae762b04e3c5761355e387eefc601d.svg";
export { ForwardRef as ReactComponent };